import React from 'react';

export const Heading = (props) => {
  let styles = props.styles;
  return (
    <div className={styles.divTable__header}>
      <div className={styles.divTable__hItem}>Currency</div>
      <div className={styles.divTable__hItem}>transfer rate</div>
      <div className={styles.divTable__hItem}>cash buy</div>
      <div className={styles.divTable__hItem}>cash sell</div>
    </div>
  );
};
